import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ShopProvider } from "@/context/ShopContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Collections from "@/pages/Collections";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Wishlist from "@/pages/Wishlist";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutResult from "@/pages/CheckoutResult";
import CollectionPage from "@/pages/CollectionPage";
import FamilyPage from "@/pages/FamilyPage";
import Track from "@/pages/Track";
import Search from "@/pages/Search";
import CustomerCare from "@/pages/CustomerCare";
import FabricGuide from "@/pages/FabricGuide";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ShopProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-ivory text-espresso">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:slug" element={<CollectionPage />} />
              <Route path="/colours/:slug" element={<FamilyPage />} />
              <Route path="/track" element={<Track />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/result" element={<CheckoutResult />} />
              <Route path="/search" element={<Search />} />
              <Route path="/customer-care" element={<CustomerCare />} />
              <Route path="/fabric-guide" element={<FabricGuide />} />
              <Route path="/lamsah-admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#2B211C", color: "#F7F1E8", border: "none", borderRadius: 0 } }} />
      </BrowserRouter>
    </ShopProvider>
  );
}

export default App;
